export default "__VITE_ASSET__598313db__"